import { useEffect, useState, createContext, useContext } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/defaultContent";

const ContentContext = createContext({ content: DEFAULT_CONTENT, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  // Initialize with hardcoded defaults so the very first paint (server-rendered or
  // pre-crawler snapshot) contains real, indexable content — not a "Loading…" placeholder.
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const fetchContent = async () => {
    try {
      const { data } = await api.get("/content");
      // Merge over defaults so any missing key falls back to DEFAULT_CONTENT.
      setContent({ ...DEFAULT_CONTENT, ...data });
    } catch (e) {
      console.error("content fetch failed", e);
      // Keep DEFAULT_CONTENT — never go blank.
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  return (
    <ContentContext.Provider value={{ content, refresh: fetchContent }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
